import React from 'react';
import {Truck, PackageCheck, Warehouse, RotateCcw, Building2, Star} from 'lucide-react';

const services = [
    {
        Icon: Warehouse,
        title: 'Warehousing & Storage',
        description: 'Secure, organized warehousing solutions for businesses of all sizes. Your inventory is safe, tracked, and ready to ship at a moment\'s notice.',
        features: ['Flexible storage plans', 'Inventory management', 'Climate-controlled options'],
        accent: '#0a4abe',
        bg: '#f0efe9',
    },
    {
        Icon: PackageCheck,
        title: 'Orders Fulfillment',
        description: 'We receive, process, and ship your customer orders seamlessly. Plug into our fulfillment infrastructure and focus on growing your business.',
        features: ['Order processing', 'Pick & pack', 'Same-day dispatch'],
        accent: '#0a4abe',
        bg: '#fefce8',
    },
    {
        Icon: Truck,
        title: 'Domestic Delivery',
        description: 'Fast and reliable delivery across all of Lebanon. Whether it\'s a single package or bulk shipments, we get it there on time, every time.',
        features: ['Nationwide coverage', 'Real-time tracking', 'Proof of delivery'],
        accent: '#0a4abe',
        bg: '#e8effc',
    },
    {
        Icon: RotateCcw,
        title: 'Returns Management',
        description: 'Hassle-free reverse logistics. We handle the collection, inspection, and restocking of returned items so you don\'t have to.',
        features: ['Scheduled collections', 'Item inspection & sorting', 'Restocking & reporting'],
        accent: '#0a4abe',
        bg: '#e8effc',
    },
    {
        Icon: Building2,
        title: 'Corporate Logistics',
        description: 'Tailored logistics solutions for enterprises — inter-branch transfers, corporate mail, bulk distribution, and dedicated fleet options.',
        features: ['Dedicated account manager', 'SLA-backed service', 'Custom routing & scheduling'],
        accent: '#0a4abe',
        bg: '#fefce8',
    },
    {
        Icon: Star,
        title: 'Full Fulfillment',
        description: 'The complete package. From the moment an order is placed to the moment it\'s in your customer\'s hands — we own the entire journey, A to Z.',
        features: ['End-to-end order handling', 'Storage, packing & delivery', 'Returns & customer comms'],
        accent: '#f9d800',
        bg: '#0a4abe',
        featured: true,
    },
];

export default function Services() {
    return (
        <section id="services" className="bg-white lg-custom:py-20 py-12">
            <div className="dh-container">
                <div style={{ textAlign: 'left', marginBottom: '2.5rem' }}>
                    <div className="uppercase" style={{
                        display: 'inline-block', background: '#e8effc', color: '#0a4abe',
                        borderRadius: '100px', padding: '3px 14px', fontSize: '12px',
                        fontFamily: "'Inter'", fontWeight: 500, marginBottom: '13px', letterSpacing: '0.5px',
                    }}>
                        what we offer
                    </div>
                    <h2 style={{
                        fontFamily: "'Bebas Neue'",
                        fontWeight: 900,
                        fontSize: 'clamp(2.5rem, 5vw, 4.5rem)',
                        lineHeight: '0.95',
                        marginBottom: '1.5rem',
                    }}>
                        end-to-end<br/>logistics
                    </h2>
                    <div className="text-neutral-500 text-base" style={{
                        fontFamily: "'Inter'",
                        lineHeight: 1.65,
                        textAlign: 'justify',
                        maxWidth: '32rem',
                    }}>
                        Whether you're a startup shipping your first orders or an enterprise managing complex supply chains, we have the
                        infrastructure.
                    </div>
                </div>

                <div
                    style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '15px' }}>
                    {services.map(( s ) => {
                        const { Icon } = s;
                        return (
                            <div key={s.title} style={{
                                background: s.featured ? '#0a4abe' : '#ffffff',
                                borderRadius: '15px',
                                padding: '36px',
                                border: s.featured ? 'none' : '1px solid #e0dfd6',
                                transition: 'transform 0.2s, box-shadow 0.2s',
                                position: 'relative',
                                overflow: 'hidden',
                            }}
                                 onMouseEnter={e => {
                                     e.currentTarget.style.transform = 'translateY(-4px)';
                                     e.currentTarget.style.boxShadow = s.featured
                                         ? '0 12px 40px rgba(10,74,190,0.35)'
                                         : '0 12px 40px rgba(10,74,190,0.1)';
                                 }}
                                 onMouseLeave={e => {
                                     e.currentTarget.style.transform = 'none';
                                     e.currentTarget.style.boxShadow = 'none';
                                 }}
                            >
                                {/* Top accent line */}
                                <div style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    height: '3px',
                                    background: s.accent,
                                    borderRadius: '20px 20px 0 0'
                                }}/>

                                {s.featured && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '16px',
                                        right: '16px',
                                        background: '#f9d800',
                                        color: '#0a4abe',
                                        borderRadius: '100px',
                                        padding: '3px 12px',
                                        fontSize: '11px',
                                        fontFamily: "'Inter'",
                                        fontWeight: 700,
                                        letterSpacing: '0.5px',
                                    }}>
                                        MOST POPULAR
                                    </div>
                                )}

                                <div style={{
                                    width: '52px', height: '52px', borderRadius: '14px',
                                    background: s.featured ? 'rgba(249,216,0,0.15)' : s.bg,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    marginBottom: '20px',
                                }}>
                                    <Icon size={24} color={s.featured ? '#f9d800' : '#0a4abe'} strokeWidth={1.75}/>
                                </div>

                                <h3 style={{
                                    fontFamily: "'Outfit'",
                                    fontWeight: 700,
                                    fontSize: '20px',
                                    marginBottom: '12px',
                                    color: s.featured ? '#ffffff' : '#0d0d0d'
                                }}>{s.title}</h3>
                                <p style={{
                                    fontFamily: "'Inter'",
                                    color: s.featured ? 'rgba(255,255,255,0.75)' : '#5c5c56',
                                    fontSize: '15px',
                                    lineHeight: 1.65,
                                    marginBottom: '24px'
                                }}>{s.description}</p>

                                <ul style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    {s.features.map(f => (
                                        <li key={f} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <div style={{
                                                width: '20px',
                                                height: '20px',
                                                borderRadius: '50%',
                                                background: s.featured ? 'rgba(249,216,0,0.2)' : '#e8effc',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                flexShrink: 0,
                                            }}>
                                                <span style={{
                                                    color: s.featured ? '#f9d800' : '#0a4abe',
                                                    fontSize: '11px',
                                                    fontWeight: 700
                                                }}>✓</span>
                                            </div>
                                            <span style={{
                                                fontFamily: "'Inter'",
                                                fontSize: '14px',
                                                color: s.featured ? 'rgba(255,255,255,0.85)' : '#2a2a27'
                                            }}>{f}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}